import React from 'react';
import { ProductItem } from '../../productItem/ProductItem';

import { useHotSellQuery, useRecomendedProductsQuery } from '../ApiRequests';
import { HotSellPanel } from '../hotSellPanel/HotSellPanel';
import { HotSellProduct } from '../hotSellPanel/Types';
import styles from './RecommendedProducts.module.css';

export const RecommendedProducts = () => {
    const hotSellQuery = useHotSellQuery();
    const recomenderProductsQuery = useRecomendedProductsQuery();

    //for debug use
    const timeToEnd = new Date();
    timeToEnd.setDate(new Date().getDate() + 1);
    timeToEnd.setHours(10, 0, 0, 0);
    // if api wont provide hot sell data, we wont show HotSellPanel component
    let hotSellProduct: HotSellProduct | undefined;
    if (hotSellQuery.data) {
        hotSellProduct = hotSellQuery.data;
        hotSellProduct!.endDateTime = timeToEnd.getTime()
    }

    if (hotSellQuery.isLoading || recomenderProductsQuery.isLoading) {
        return <span>Loading...</span>
    }

    if (hotSellQuery.isError || recomenderProductsQuery.isError) {
        return (
            <div>
                {recomenderProductsQuery.isError && <span>Error: {recomenderProductsQuery.error.message}</span>}
                {hotSellQuery.isError && <span>Error: {hotSellQuery.error.message}</span>}
            </div>
        );
    }

    return (
        <section className={styles.recommendedProductsSection}>
            {hotSellProduct && <HotSellPanel product={hotSellProduct} />}
            <div className={styles.recommendedProducts}>
                {
                    recomenderProductsQuery.data.map((loadedProduct) => {
                        return (
                            <a href={`/Product/${loadedProduct.id}`} className={styles.recommendedProduct} key={loadedProduct.id}>
                                <ProductItem
                                    bestseller={loadedProduct.category.bestseller}
                                    freeShipping={loadedProduct.category.freeShipping}
                                    id={loadedProduct.id}
                                    imageSrc={loadedProduct.imageSrc}
                                    name={loadedProduct.name} price={loadedProduct.price}
                                    promotionPrice={loadedProduct.promotionPrice} />
                            </a>
                        );
                    })
                }
            </div>
        </section>
    );
}
